<template lang="pug">
.padding
    .row
        .col-md-4
            .m-b-sm
                h5.m-b-0.p-t-sm._300 Import Inventory

        .col-md-12
            .box.padding.m-t-sm
                .row
                    .col-md-5
                        form(
                            :action="url"
                            method="post"
                            enctype="multipart/form-data"
                        )
                            input(type="hidden" name="_token" :value="token")
                            input.form-control(type="file" name="file")
                            input.m-t-md.pull-right.btn.green(type="submit" value="Submit")
                            button.m-t-md.pull-right.btn.m-r-sm(@click="cancelUpload" type="button") Cancel
</template>

<script>
export default {
    data: () => ({
        token: null,
    }),

    computed: {
        url() {
            return Laroute.route('stocks.inventories.import');
        },
    },

    mounted() {
        this.token = $('meta[name="csrf-token"]').attr('content');
    },

    methods: {
        cancelUpload() {
            this.$router.push(`/`);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock/stock-import.vue